import { defaultButtonPaddingObject } from '../../../defaults';
import { getPxValue } from '../../../line-height-to-px';
export function makePaddingString({ padding: { top, right, bottom, left }, defaultPadding: { top: defaultTop, right: defaultRight, bottom: defaultBottom, left: defaultLeft, } = defaultButtonPaddingObject, }) {
    const hasValue = (value) => value !== undefined && value !== '';
    const resolveValue = (primary, secondary, fallback) => {
        if (hasValue(primary)) {
            return getPxValue(primary);
        }
        else if (hasValue(secondary)) {
            return getPxValue(secondary);
        }
        return getPxValue(fallback);
    };
    const resolved = [
        resolveValue(top, bottom, defaultTop),
        resolveValue(right, left, defaultRight),
        resolveValue(bottom, top, defaultBottom),
        resolveValue(left, right, defaultLeft),
    ];
    return resolved.join(' ');
}
//# sourceMappingURL=make-padding-string.js.map